import React, { useEffect } from 'react';
import './notification-container.scss';
import CustomIcon, { IconType } from '../../shared/custom-icon/custom-icon';
import { useStores } from '../../store';
import { PopoverGotIt } from '../../shared/popover/popover-got-it';
import NotificationContainer from './notification-container';
import { observer } from 'mobx-react-lite';
import { IsNotificationTooltipShowedKey, NOTIFICATION_TEXT } from '@src/utils/constants';
import { EventType } from '@src/dtos/analytics.dto';

interface NotificationButtonProps {
    fetchAllServices?: boolean;
}

const NotificationButton: React.FC<NotificationButtonProps> = observer(({ fetchAllServices }) => {

    const { notificationStore, userPreferencesStore } = useStores();

    useEffect(() => {
        return () => {
            notificationStore.setNotificationVisible(false);
        };
    }, []);

    useEffect(() => {
        if (!localStorage.getItem(IsNotificationTooltipShowedKey) && !!notificationStore.newNotificationsCount) {
            notificationStore.setNotificationPopoverText(NOTIFICATION_TEXT);
            notificationStore.setIsNotificationTooltipShow(true);
            localStorage.setItem(IsNotificationTooltipShowedKey, 'true');
        }
        return (() => notificationStore.setIsNotificationTooltipShow(false));
    }, [notificationStore.newNotificationsCount]);

    const closeNotification = () => {
        notificationStore.setNotificationVisible(false);
        void userPreferencesStore.updateLastSeenDate(fetchAllServices);
    };

    const handleNotificationVisibility = () => {
        if(notificationStore.notificationVisible) {
            closeNotification();
        }
        else {
            notificationStore.setNotificationVisible(true);
            void notificationStore.loadNotifications(fetchAllServices);
            void notificationStore.loadWhatsNewLastSeen();
            notificationStore.sendGeneralEvent(EventType.LinkClicked, { button: 'notification' });
        }
    };

    return <>
        <PopoverGotIt overlayClassName="notification-popover-explain" placement="bottomRight"
                      open={notificationStore.isNotificationTooltipShow}
                      onClickGotIt={() => notificationStore.setIsNotificationTooltipShow(false)} text={notificationStore.notificationPopoverText}>
            <button type="button" className={`notification-sign ${notificationStore.notificationVisible ? 'open' : ''}`}
                 aria-label="Notifications"
                 onClick={() => !notificationStore.isNotificationTooltipShow && handleNotificationVisibility()}>
                <CustomIcon type={IconType.BELL}/>
                {(notificationStore.newNotificationsCount > 0 || notificationStore.hasWhatsNewUnread) &&
                    <span className="notification-dot" aria-hidden="true" />}
            </button>
        </PopoverGotIt>
        <NotificationContainer visible={notificationStore.notificationVisible} close={closeNotification}
                               notifications={notificationStore.notifications} fetchAllServices={fetchAllServices}/>
    </>;
});

export default NotificationButton;
